import { TodoTaskListAll } from "../entity/Entity"
import { TodoListApiImpl } from "./ServiceImpl"

const TodoListService = (api: TodoListApiImpl) => {
    const getTodoListByCategory = async (params?: any): Promise<TodoTaskListAll> => {
        const response = await api.getTodoListByCategory(params)
        return {
            pagination: response.pagination,
            results: response.results || []
        }
    }

    const getProjectById = async(params: any) => {
        const response = await api.getProjectById(params)
        return response
    }

    return { getTodoListByCategory, getProjectById }
}

export default TodoListService